import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { useLang } from "@/lib/lang";
import { api } from "@/lib/auth";
import { toast } from "sonner";

export default function ResetPassword() {
    const { t } = useLang();
    const nav = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token") || "";
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (password.length < 8) {
            toast.error(t("auth.password_too_short"));
            return;
        }
        if (password !== confirm) {
            toast.error(t("auth.password_mismatch"));
            return;
        }
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: password });
            toast.success(t("auth.reset_success"));
            nav("/login");
        } catch (err) {
            toast.error(err.response?.data?.detail || t("auth.reset_invalid"));
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
        return (
            <div className="min-h-screen bg-ink text-slate-900">
                <Navbar />
                <div className="max-w-md mx-auto px-6 pt-20 pb-24">
                    <p className="text-slate-600" data-testid="reset-no-token">{t("auth.reset_invalid")}</p>
                    <Link to="/forgot-password" className="text-brand hover:underline text-sm mt-4 inline-block">
                        {t("auth.forgot_title")}
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-ink text-slate-900">
            <Navbar />
            <div className="max-w-md mx-auto px-6 pt-20 pb-24">
                <div className="mono-label mb-4">/ RESET</div>
                <h1 className="font-display text-4xl md:text-5xl mb-3 tracking-tight" data-testid="reset-title">
                    {t("auth.reset_title")}
                </h1>
                <p className="text-slate-600 mb-10">{t("auth.reset_sub")}</p>
                <form onSubmit={submit} className="space-y-5">
                    <div>
                        <label className="mono-label block mb-2">{t("auth.new_password")}</label>
                        <input
                            data-testid="reset-password-input"
                            type="password"
                            required
                            minLength={8}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full bg-transparent border border-slate-300 px-4 py-3 rounded-sm focus:border-brand outline-none transition-colors"
                        />
                    </div>
                    <div>
                        <label className="mono-label block mb-2">{t("auth.confirm_password")}</label>
                        <input
                            data-testid="reset-confirm-input"
                            type="password"
                            required
                            minLength={8}
                            value={confirm}
                            onChange={(e) => setConfirm(e.target.value)}
                            className="w-full bg-transparent border border-slate-300 px-4 py-3 rounded-sm focus:border-brand outline-none transition-colors"
                        />
                    </div>
                    <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="reset-submit-btn">
                        {loading ? "..." : t("auth.reset_btn")}
                    </button>
                </form>
            </div>
        </div>
    );
}
